import { compose, defaultTo, map } from 'ramda';

import { clear, compact, path } from '../../../../helpers/compact';
import { CommonSliceType } from '../../../../types/slice';

const getPushsUID = compose(
  compact,
  map(path('internal-media.uid')),
  defaultTo([])
);

export const internalMedia = (obj) => {
  return clear({
    type: CommonSliceType.INTERNAL_MEDIA,
    internalMedia: getPushsUID(obj.items),
  });
};
